// removed by extract-text-webpack-plugin
module.exports = {"button-container":"purify_Header__button-container___1uxYY","Header":"purify_Header__Header___nDDeZ","text":"purify_Header__text___GuzVr","buttons":"purify_Header__buttons___3FdLK","no-margin":"purify_Header__no-margin___19FRe"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Header/Header.scss
// module id = 176
// module chunks = 0